import { get } from 'lodash';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;
export function* downloadSurveyCSV(action) {
  const payload = get(action, 'payload', {});
  const { survey } = payload;

  const serverConfig = yield select(getServerConfig);

  try {
    const path = `/survey/${serverConfig.namespace}/csv/${survey.id}`;
    yield call(API, 'get', 'api', path);
  } catch (e) {
    console.error(e);
  }
}
